module.exports = __webpack_public_path__ + "static/media/48383381_2308761149199063_2723174480170975232_o.9f3a428d.jpg";